import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import ScrollTop from '../components/ScrollTop';

import Reception from '../components/Reception';
import AboutSection from '../components/AboutSection';
import PrestaSection from '../components/PrestaSection';
import Infos from '../components/Infos';

const AboutPage = () =>{
    
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const el = document.getElementById(location.hash.replace('#', ""));
            if (el){
                el.scrollIntoView({behavior: "smooth"});
            }
        };
        document.title = "Nicolas d. | Coiffeur Saint-Marcel XIIIe";
        document
        .querySelector('meta[name="description"]')
        ?.setAttribute("content", "Nicolas d. - Salon de coiffure mixte à Paris 13e Boulevard Saint-Marcel, spécialiste coupe, couleur, brushing, et soins capillaires. Prenez rendez-vous en ligne ou par téléphone.");
        document.querySelector('meta[name="keywords"]')
        ?.setAttribute("content", "coiffeur, salon de coiffure, mixte, Paris 13e, coupe de cheveux, couleur, brushing, coloration, soins capillaires, rendez-vous en ligne, téléphone");
    }, [location]);

    return(
        <div>
            <Reception />
            <AboutSection />
            <PrestaSection />
            <Infos />
            <ScrollTop />
        </div>
    )
}

export default AboutPage;